import { CognitoUser } from "amazon-cognito-identity-js";
import { AxiosError, HttpStatusCode } from "axios";
import { Login, RespondAuthName } from "generated/models";

// Unified token response
export type TokenResponse = {
    IdToken: string;
    AccessToken: string;
    RefreshToken?: string;
    LastLogin: number;
};

// Unified MFA response
export type AuthMFAResponse = {
    ChallengeName: RespondAuthName;
    Session: CognitoUser;
    ChallengeParameters?: unknown;
};

// Unified auth response
export type AuthResponse = {
    status: HttpStatusCode;
    data?: TokenResponse | AuthMFAResponse;
    error?: AxiosError | null;
};

// MFA submission parameters
export type MFASubmissionParams = {
    session: CognitoUser | string; // CognitoUser for Cognito, session string for local
    mfaCode: string;
    challengeName?: RespondAuthName; // Optional - will default to SMS_MFA if not provided
};

// Authentication strategy interface
export interface IAuthenticationStrategy {
    login(credentials: Login): Promise<AuthResponse>;
    submitMFACode(params: MFASubmissionParams): Promise<AuthResponse>;
}

export enum AuthProvider {
    COGNITO = "cognito",
    LOCAL = "local",
    KEYCLOAK = "keycloak",
}
